import React, { useEffect } from "react";
const ColorPrediction = () => {
    const [url, setUrl] = React.useState("");
    const generateUrl = () => {
        const baseUrl = "https://lotus121-color.netlify.app/login?token=";
        const token=localStorage.getItem("token");
      setUrl( `${baseUrl}${token}`)
    }
    useEffect(() => {
        generateUrl();
    }, []);
    return (
        <div style={{ width: "100%", height: "100vh" }}>
            <iframe
                title="Color Prediction Game"

                src={url}
                style={{ width: "100%", height: "100%", border: "none" }}
            />
        </div>
    );
}
export default ColorPrediction;